import React from 'react';

import './loader.styles.scss';

export const Loader = () => {
    return (
        <div className="loader-wrapper">
            <div className="loader"></div>
        </div>
    )
}